export const isMobileUserAgent = () =>
	/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
